module.exports = __webpack_public_path__ + "static/media/quarrytruck4_preview.6a6fc0c9.jpg";